import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface WarningMessageProps {
  message: string;
  clickableText?: string;
  linkTo?: string;
  containerClassName?: string;
  textClassName?: string;
  iconClassName?: string;
}

export const WarningMessage = ({
  message,
  clickableText,
  linkTo,
  containerClassName,
  textClassName,
  iconClassName,
}: WarningMessageProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center">
      <div
        className={twMerge(
          'flex justify-center px-3 pt-4 pb-3 bg-red-FF2929/90 rounded-lg max-w-[70%] gap-2 mt-3 mb-4',
          containerClassName
        )}
      >
        <div className="-mt-1">
          <i
            className={twMerge(
              'ki-outline ki-information-1 text-white text-xl',
              iconClassName
            )}
          />
        </div>
        <div
          className={twMerge('text-white text-sm font-medium', textClassName)}
        >
          {message}{' '}
          {clickableText && linkTo && (
            <span
              data-modal-dismiss="true"
              className="underline hover:cursor-pointer"
              onClick={() => {
                setTimeout(() => {
                  navigate(linkTo);
                }, 0);
              }}
            >
              {clickableText}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
